import { useDispatch, useSelector } from 'react-redux';
import { ActionType } from "../model";
import { RootState } from "../reducers";



export function createPageHooks<Schema extends Record<string, any>>() {
    function usePageProp<K extends keyof Schema>(key: K): Schema[K] {
        return useSelector((state:RootState) => state.currentPage[key]);
    }

    function useSetPageProp() {
        const dispatch = useDispatch();
        return <K extends keyof Schema>(key: K, value: Schema[K]) => {
            dispatch({
                type: ActionType.SET_PAGE_PROP,
                payload: { key, value },
            });
        };
    }

    function useClearPage() {
        const dispatch = useDispatch();
        return <K extends keyof Schema>(key?: K) => {
            dispatch({
                type: ActionType.CLEAR_PAGE,
                payload: key ? { keys: [key] } : undefined,
            });
        };
    }

    return {
        usePageProp,
        useSetPageProp,
        useClearPage
    };
}
